import { createSelector } from "@ngrx/store";
import { ICondicionalState } from "./condicional.reducer";


const CondicionalReleaseStore = (state: any) => state.condicional as ICondicionalState;
const CondicionalTriggerStore = (state: any) => state.condicional as ICondicionalState


export const selectRelease = createSelector(
    CondicionalReleaseStore,
    (state) => state.release
);

export const selectTrigger = createSelector(
    CondicionalTriggerStore,
    (state) => state.trigger
);